$ = jQuery;

$(function(){
  if($('.home').length>0){

    $('.home select[name=realty__type] option[value=Коммерческая]').prop('selected', true);
  }

  if($('.page-template-page_search').length>0){   

    if($('.page-template-page_search select[name=realty__type] option:selected').text()=='Тип недвижимости'){

      $('.page-template-page_search select[name=realty__type] option[value=Коммерческая]').prop('selected', true);

    }
  }

  if($('#edit_mydata').length>0){

    var html = $('.acf-field-5ba8ddd9d90e5 .acf-label').html();

    $('.acf-field-5ba8ddd9d90e5 .acf-label').remove();

    $('.acf-field-5ba8ddd9d90e5').append('<div class="acf-label">'+html+'</div>');

    

    var html = $('#edit_mydata .acf-field-5ba8ddd9d90e5 .acf-label p.description').text();

    html = html.split('*');

    var string = '*'+html[1]+'<br><br>*'+html[4];   

    $('#edit_mydata .acf-field-5ba8ddd9d90e5 .acf-label p.description').html(string);

        

    //$('#edit_mydata .acf-field-5ba8def9718ff').remove();

    //$('#edit_mydata .acf-field-5ba8df0c71900').remove();



    $('#edit_mydata .acf-form-submit input').val('СОХРАНИТЬ ДАННЫЕ');

    $('#edit_mydata .hide-if-value').html('<p style="text-align: center"><a data-name="add" class="acf-button button" href="#">Добавить фото</a></p>');

    

    $('#edit_mydata .acf-field-5ba8de7034424 .button-primary').html('<i class="fa fa-plus-square"></i> Добавить телефон');



    $('#edit_mydata .acf-field-5ba8ddb4d90e4').append('<div class="acf-field acf-field-text acf-field-login" data-name="login" data-type="text" data-key="acf-field-login" data-required="1"><div class="acf-label"><label for="acf-field-login-input">Логин</label></div><div class="acf-input"><div class="acf-input-wrap"><input type="text" id="acf-field-login-input" name="acf-field-login-input" value="" ></div></div></div>');

    $('#edit_mydata .acf-field-5ba8ddb4d90e4').append('<div class="acf-field acf-field-text acf-field-pass" data-name="pass" data-type="text" data-key="acf-field-pass" data-required="1"><div class="acf-label"><label for="acf-field-pass-input">Пароль</label></div><div class="acf-input"><div class="acf-input-wrap"><input type="password" id="acf-field-pass-input" name="acf-field-pass-input" value="" ></div></div></div>');

    $('#edit_mydata .acf-field-5ba8ddb4d90e4').append('<div class="acf-field acf-field-text acf-field-morepass" data-name="morepass" data-type="text" data-key="acf-field-morepass" data-required="1"><div class="acf-label"><label for="acf-field-morepass-input">Повторить пароль</label></div><div class="acf-input"><div class="acf-input-wrap"><input type="password" id="acf-field-morepass-input" name="acf-field-morepass-input" value="" ></div></div></div>');
  }

  $('.update_object').click(function(e){

    e.preventDefault();

    $(this).removeClass('update_object');

    var elem = $(this);

    var id = $(this).attr('href');    

    if(id!=''){

      $(this).attr('href', false);

      $(this).css('color', '#b9b8b8');

      jQuery.ajax({

        url : offerget.ajax_url,

        type : 'post',

        data : {

          action : 'update_object',

          up : id

        },

        success : function( response ) {        

          if(response && response!='') {    

            elem.closest('.realty_item').find('.realty_date').text(response);

          }

        } 

      }); 

    }
  });
});

/* Header menu mobile slide toggle */
$(function(){
  $('[data-mobile-menu-show]').on('click', function(e){
    e.preventDefault();

    let target    = this.getAttribute('data-mobile-menu-show');
    let targetEl  = $('[data-mobile-menu="' + target + '"]');

    if(targetEl.length) {
      targetEl.show('slide', {direction: "up"}, 400);
      targetEl.addClass('active');
    }
  });

  $('.header__close').on('click', function(e){
    e.preventDefault();

    let menuEl = $(this).closest('[data-mobile-menu]');

    // hide
    if(menuEl.length) {
      menuEl.hide('slide', {direction: "left"}, 400, function(){
        $(this).removeClass('active');
      });
    }
  }); 
});
/* Header menu mobile slide toggle END */

/* Footer on bottom */
$(function(){
  let footer = $('.footer'),
  height = footer.outerHeight();

  // set body padding-bottom to footer height
  $('body').css('padding-bottom', height);
});
/* Footer on bottom END */